import React from 'react'
import styled from 'styled-components'
import Frill from '../assets/frill.png'
import Link from 'gatsby-link'

const FooterWrapper = styled.div`
  #contact {
    background-image: url(${Frill});
    background-position: bottom;
    background-repeat: repeat-x;

    margin-top: 50px;
    border-bottom: solid 2px #7ecfd1;
  }

  .bottom {
  }
  .call-to-action {
    margin: 10px;
    margin-top: 20px;
    transition: margin 300ms ease;
    a {
      transition: color 300ms ease;
    }
    border: solid 1px transparent;
    background-color: transparent;
  }
  .call-to-action:not(.disable) {
    &:hover {
      border: solid 1px #7ecfd1;
      border-radius: 10px;
      background-color: #fff;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
`

const Footer = ({ location }) => (
  <FooterWrapper>
    <section id="contact" className="section is-medium has-text-centered">
      <div className="columns">
        <div className="column">
          <p className="pacifico is-size-3 has-text-primary">
            Ready to build amazing things?
          </p>
          <div className="columns is-centered">
            <div className="column is-6 is-3-desktop">
              <div
                className={
                  'call-to-action' +
                  (location.pathname == '/contact' ? ' disable' : '')
                }
              >
                {location.pathname == '/contact' ? (
                  <p
                    style={{ fontFamily: 'oswald' }}
                    className="is-uppercase has-text-weight-bold is-size-1 is-size-2-tablet is-size-3-mobile has-text-dark"
                  >
                    We Thought You Might
                  </p>
                ) : (
                  <Link
                    style={{ fontFamily: 'oswald' }}
                    to="/contact"
                    className="is-uppercase has-text-weight-bold is-size-1 is-size-2-tablet is-size-3-mobile has-text-dark"
                  >
                    Get In Touch
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="bottom columns">
        <div className="column has-text-centered has-text-primary">
          <p>© Copyright 2018 Mega House Creative Agency</p>
        </div>
      </div>
    </section>
  </FooterWrapper>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js